import { render } from "./RiattivazioniRichiesteTable.vue?vue&type=template&id=0973d5be&scoped=true"
import script from "./RiattivazioniRichiesteTable.vue?vue&type=script&lang=js"
export * from "./RiattivazioniRichiesteTable.vue?vue&type=script&lang=js"

import "./RiattivazioniRichiesteTable.vue?vue&type=style&index=0&id=0973d5be&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0973d5be"]])

export default __exports__